import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';

import PlayList from '../partials/modules/playList';
import CustomVideoPlayer from '../partials/components/customVideoPlayer';
import MainChat from '../partials/components/mainChat';
import Greeting from '../partials/blocks/greeting';
import MultiBlockSelection from '../partials/components/multiBlockSelection'
import Countdown from '../partials/components/countdown'
import TopBarAlertManager from '../partials/components/topBarAlertManager'
import RoomTimeSelection from '../partials/components/roomTimeSelection'
import { useRootContext } from '../partials/context/rootContext';

import ReactGA from 'react-ga4';

const MainSession = ({...props}) => {
    const {dataContext, setDataContext, scheduleContext, setScheduleContext } = useRootContext();
    const [rooms, setRooms] = useState([]);
    const [myRooms, setMyRooms] = useState([]);
    const [currentRoom, setCurrentRoom] = useState({});
    const [timeSlots, setTimeSlots] = useState({});
    const [otherRooms, setOtherRooms] = useState([]);
    const [initialized, setInitialized] = useState(false);
    const [isPlaylistActive, setIsPlaylistActive] = useState(true);
    const [postEventMessage, setPostEventMessage] = useState(false);


    //When Items updates
    useEffect(() => {
        //Sort rooms based on start time       
        let newRooms = dataContext.rooms.sort((a,b) => (moment(a.start).isAfter(moment(b.start))) ? 1 : -1);
        console.log("NEW ROOMS", newRooms);
        //Filter out rooms from other days
        const today = moment().tz('America/New_York').format('YYYY-MM-DD');
        newRooms = newRooms.filter((room)=>{
            if((moment(room.start).format('YYYY-MM-DD') == today) && (room.room_type.value == 'main_stage' || room.room_type.value == 'breakout' || room.room_type.value == 'lunch' || room.room_type.value == 'intermission')) return true;
        });
        console.log("NEW ROOMS", newRooms);
        //Groups Time Slots
        let newTimeSlots = [];
        newRooms.map((room) => {
            const timeSlot = moment(room.start).format('HH:mm:ss');
            newTimeSlots[timeSlot] = newTimeSlots[timeSlot] || [];
            newTimeSlots[timeSlot].push(room);
            return room;
        });


        setTimeSlots(newTimeSlots);
        setRooms(newRooms);

        console.log("New Rooms", newRooms);
        
        setMyRooms(newRooms.filter((room) => {
            if(room.registered) return true;
        }));

        setTimeout(()=>{setInitialized(true)}, 1000);
    }, [dataContext.rooms]);

    useEffect(() => {
        let currentTimeSlot = timeSlots[moment(currentRoom.start).format('HH:mm:ss')];        
        if(currentTimeSlot){
            let options = currentTimeSlot.filter((room) => {
                if((room.unique != currentRoom.unique) && (room.auto_register == false)) return true;
            })            
            setOtherRooms(options);
        }
        if(typeof currentRoom.title !== 'undefined') {
            console.log('about to GA!', currentRoom.title, currentRoom.start);
            ReactGA.event({
                category: "Streams",
                action: "Watch",
                label: currentRoom.title + ' | ' + currentRoom.start, // optional
                nonInteraction: true // optional, true/false
            });
        }
    }, [currentRoom]);

    useEffect(() => {
        let post_event_message = false;
        if(props.data.event.post_event_messages) {
            props.data.event.post_event_messages.forEach(message => {
                if(moment().format('YYYYMMDD') === moment(message.date).format('YYYYMMDD')) {
                    post_event_message = message.message;
                }
            });
        }
        setPostEventMessage(post_event_message);
    }, [props.data.event.post_event_messages]);
    
    const getNextRoomStarTime = () =>
    {
        
        let nextRoom = rooms.find((room) => {
            if(room.start > moment().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss')) return true;
        });
        
        if(nextRoom) return nextRoom.start;
        return false;
    }

    const getOriginalStartTime = () => {

        //find the original start time of the video (across multiple rooms if necessary)
        let originalStartTime = false;
        for(let i=0; i<rooms.length; i++){
            if(rooms[i].videoID == currentRoom.videoID) {
                originalStartTime = rooms[i].start;
                break;
            }
        }

        return (currentRoom && currentRoom.match_elapsed_time) ? originalStartTime : false;
    }
    console.log("Initialized", initialized);
    console.log("isPlaylistActive", isPlaylistActive);
    return( 
        <div className="px-4 font-sans container">
            <TopBarAlertManager alerts={currentRoom.scheduled_alerts} />
            <Greeting 
                firstName={props.data.attendee.first_name} 
                location={props.data.event.location_below_greeting ? props.data.attendee.location : 'Non-Regional'}
            />
            
            {/* If no room has started yet but there is one coming up */}
            {initialized && isPlaylistActive && !currentRoom.stream && myRooms.length > 0 && (
                <Countdown 
                    title="Today's events start in:" 
                    targetTime={getNextRoomStarTime()}
                />
            )}

            {/* If the schedule is over, show post event message */}
            {initialized && !isPlaylistActive && postEventMessage && (
                <div dangerouslySetInnerHTML={{__html: postEventMessage}}></div>
            )}

            {/* If there is a current room stream */}
            {isPlaylistActive && currentRoom.stream && (
                <div>
                    <h2 className="text-xl lg:text-4xl font-bold text-gray-700 py-2 w-full">
                        {currentRoom.title}
                    </h2>
                    <div className="flex flex-wrap lg:space-x-3 ">
                    {currentRoom.disable_chat ? (
                        <>
                        <div className="lg:flex-1 w-full  mb-3 lg:mb-0">
                            <div className="rounded-huge overflow-hidden">
                                <CustomVideoPlayer currentRoom={currentRoom} videoID={currentRoom.stream} videoType={currentRoom.video_type} originalStartTime={getOriginalStartTime()} key={currentRoom.stream}  />
                            </div>
                        </div>
                        </> ) : (<>
                            <div className="lg:flex-1 w-full  lg:w-2/3 mb-3 lg:mb-0">
                            <div className="rounded-huge overflow-hidden">
                                <CustomVideoPlayer currentRoom={currentRoom} videoID={currentRoom.stream} videoType={currentRoom.video_type} originalStartTime={getOriginalStartTime()} key={currentRoom.stream} />
                            </div>
                        </div>
                        <div className="w-full lg:w-1/3 relative">
                            <MainChat attendee={props.data.attendee} mainChatLabel={props.data.event.main_chat_label} currentRoom={currentRoom} />
                        </div></>
                        )}
                        
                    </div>
                    <div className="prose w-full max-w-full pt-4" dangerouslySetInnerHTML={{__html: currentRoom.video_caption}}></div>
                    
                </div>
            )}

            {/* If there are other rooms to join during this timeslot */}
            {otherRooms.length > 0 && isPlaylistActive &&  (
                <div className="flex flex-wrap">
                    <h3 className="text-xl lg:text-3xl font-bold text-gray-700 pt-8 w-full">
                        Live Now
                    </h3>
                    <MultiBlockSelection 
                        rooms={ otherRooms } 
                        buttonText="Join Now"
                        onButtonClick={ setCurrentRoom }
                    />
                </div>
            )}

            {/* If the user has not registered for anything, allow him to register inline */}
            {myRooms.length == 0 && (
                <RoomTimeSelection onRoomUpdate={() =>window.location.reload(false)} />
            )}
                
            <PlayList 
                items={ rooms } 
                onButtonClick={ (i, item)=>{console.log("CLICKED", i, item)} } 
                onItemReady={ setCurrentRoom }
                onPlaylistEnd={ ()=>{setIsPlaylistActive(false)} }
            />
            

            
        </div>
    );
}


export default MainSession;